// extracted by mini-css-extract-plugin
export default {"label":"styles__label___xYZRn"};